import { DeviceStatusInfo } from "@fairfleet/geotab";
import { default as NavigationIcon, default as SvgIcon } from "@mui/icons-material/Navigation";
import SquareRoundedIcon from "@mui/icons-material/SquareRounded";
import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { useStatusData } from "@/hooks/statusData/useStatusData";
import { DeviceStatusOverviewData } from "@/models/DeviceStatusOverviewData";
import ParkingBrakeIcon from "@assets/ISO/ISO_7000_-_Ref-No_0238.svg?react";

export function DrivingCell(props: GridRenderCellParams<DeviceStatusOverviewData>) {
  const deviceId = props.row.device?.id;
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { activeSessionId } = useGeotabClient();
  const cachedData = queryClient.getQueryData<DeviceStatusInfo>([
    "DeviceStatusInfo",
    activeSessionId,
    deviceId,
  ]);

  // DTCO TellTale (Driver card)
  const { data, isLoading } = useStatusData(["afcnnV0E97EOCwYsyfOXmvA"], [deviceId]);
  const dtcoRed = data?.["afcnnV0E97EOCwYsyfOXmvA"]?.[deviceId] === 1;
  const color = !isLoading && dtcoRed ? "warning" : "primary";

  const isDriving = cachedData?.isDriving ?? props.row.statusData?.isDriving;
  const parkingBrakeActive = [1, 3].includes(
    props.row?.statusData?.statusData.find(d => d.diagnostic.id === "a8Q59homXrESC9eF_I_JTWA")
      ?.data ?? NaN,
  );

  return (
    <Tooltip
      title={
        (isDriving ? t("yes") : parkingBrakeActive ? t("faultOverview.parkingBrake") : t("no")) +
        (dtcoRed ? ` (${t("faultOverview.withoutDriverCard")})` : "")
      }
    >
      {isDriving ? (
        <NavigationIcon color={color} fontSize="small" sx={{ m: "auto" }} />
      ) : parkingBrakeActive ? (
        <SvgIcon
          component={ParkingBrakeIcon}
          color={color}
          inheritViewBox
          sx={{ borderRadius: "50%", "& path": { fill: "currentColor" } }}
        />
      ) : (
        <SquareRoundedIcon color={color} fontSize="small" sx={{ m: "auto" }} />
      )}
    </Tooltip>
  );
}
